module.exports = function anonymous(it
/**/) {
var out='<div data-widget="FilterRow" class="filter__row';if(it.IsHidden){out+=' hidden';}out+='"> <div class="filter__select" data-widget="CustomSelect"> <select name="'+(it.Name)+'" id="'+(it.Name)+'"> ';var arr1=it.Options;if(arr1){var item,index=-1,l1=arr1.length-1;while(index<l1){item=arr1[index+=1];out+=' <option';if(item.Selected){out+=' selected';}if(item.Value || item.Value === 0){out+=' value="'+(item.Value)+'"';}out+='>'+(item.Text)+'</option> ';} } out+=' </select> </div> <ul data-filter-list class="filter__list"> ';if(it.rowIndex === 0){out+=' <li class="filter__item filter__item--text"><span>Filter by</span></li> ';}out+=' </ul></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/templates/filterRow.dot
 ** module id = 253
 ** module chunks = 0 1
 **/